import React, { useState } from 'react';
import { adminLogin } from '../api';
import { useNavigate } from 'react-router-dom';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      await adminLogin({ username, password });
      localStorage.setItem('isAdminLoggedIn', 'true');
      onLogin();
      navigate('/loans');
    } catch (err) {
      setError('Invalid Username or Password');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="d-flex flex-column vh-100" style={{ backgroundColor: '#f0f2f5' }}>

      {/* --- 1. TOP GOV STRIP --- */}
      <div className="py-1 px-3" style={{ backgroundColor: '#212529', color: '#ccc', fontSize: '0.75rem' }}>
        <div className="container d-flex justify-content-between align-items-center">
          <span>Government of India</span>
          <span>Ministry of Social Justice & Empowerment</span>
        </div>
      </div>

      {/* --- 2. MAIN HEADER (Removed Border) --- */}
      <header className="bg-white shadow-sm">
        <div className="container py-3">
          <div className="row align-items-center">

            {/* Logo & Organization Name */}
            <div className="col-lg-8 d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-lg-start mb-3 mb-lg-0 text-center text-md-start">
              <img
                src="https://ik.imagekit.io/nanoplex/Project%20Image/NSFDC/nsfdclogo-removebg-preview_aCQYROM-P.png?updatedAt=1763554348489"
                alt="NSFDC Logo"
                style={{ height: '70px' }}
                className="me-md-3 mb-2 mb-md-0"
              />
              <div style={{ lineHeight: '1.2' }}>
                <h1 className="m-0 fw-bold" style={{ fontSize: '1.25rem', color: '#0D1B5E' }}>
                  National Scheduled Castes Finance and Development Corporation
                </h1>
                <small className="text-secondary fw-semibold text-uppercase" style={{ fontSize: '0.65rem', letterSpacing: '1px' }}>
                  (A Government of India Undertaking)
                </small>
              </div>
            </div>

            {/* Portal Badge */}
            <div className="col-lg-4 d-flex justify-content-center justify-content-lg-end">
              <span
                className="px-4 py-2 rounded-pill fw-bold shadow-sm d-inline-flex align-items-center"
                style={{
                  backgroundColor: '#E8F1F8',
                  color: '#0D1B5E',
                  fontSize: '0.85rem',
                  letterSpacing: '1px',
                  textTransform: 'uppercase'
                }}
              >
                <i className="bi bi-shield-lock-fill me-2" style={{ fontSize: '1rem' }}></i>
                BEAM Admin Portal
              </span>
            </div>

          </div>
        </div>
      </header>

      {/* --- 3. MAIN LOGIN SECTION --- */}
      <div className="flex-grow-1 d-flex justify-content-center align-items-center"
        style={{
          background: 'linear-gradient(135deg, #0D1B5E 0%, #2948ff 100%)',
          position: 'relative'
        }}>

        {/* Pattern Overlay */}
        <div style={{
          position: 'absolute', width: '100%', height: '100%',
          backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
          backgroundSize: '20px 20px', opacity: 0.1
        }}></div>

        <div className="card shadow-lg border-0" style={{ width: '400px', margin: '20px', zIndex: 1 }}>
          <div style={{
    height: '6px',
    background: 'linear-gradient(90deg, rgba(255, 153, 51, 1) 100%, rgba(255, 153, 51, 0.8) 100%, rgba(255,255,255,1) 100%, rgba(255,255,255,1) 0%, rgba(19,136,8,0.8) 0%, rgba(19,136,8,1) 0%)'
}}></div>
        <div className="card-body p-4">
          <div className="text-center mb-4">
            <h4 className="fw-bold mt-2" style={{ color: '#0D1B5E' }}>Portal Login</h4>
            <p className="text-muted small">Secure access for NSFDC Officials</p>
          </div>

          {error && (
            <div className="alert alert-danger d-flex align-items-center py-2" role="alert">
              <i className="bi bi-exclamation-circle-fill me-2"></i>
              <small>{error}</small>
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-floating mb-3">
              <input
                type="text"
                className="form-control"
                id="floatingInput"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
              <label htmlFor="floatingInput">Username / ID</label>
            </div>

            <div className="form-floating mb-4">
              <input
                type="password"
                className="form-control"
                id="floatingPassword"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <label htmlFor="floatingPassword">Password</label>
            </div>

            <button
              type="submit"
              className="btn btn-primary w-100 py-2 fw-bold text-uppercase"
              style={{ backgroundColor: '#0D1B5E', borderColor: '#0D1B5E' }}
              disabled={isLoading}
            >
              {isLoading ? 'Verifying...' : 'Login'}
            </button>
          </form>

          {/* <div className="text-center mt-3">
              <button 
                className="btn btn-link text-decoration-none small text-muted"
                onClick={(e) => e.preventDefault()}
                style={{ fontSize: '0.9rem' }}
              >
                Forgot Password?
              </button>
            </div> */}
        </div>

        <div className="card-footer bg-light text-center py-2">
          <small className="text-muted" style={{ fontSize: '0.7rem' }}>
            For Official Use Only. IP Address Logged.
          </small>
        </div>
      </div>
    </div>

      {/* --- 4. DESIGNED FOOTER --- */ }
  <footer style={{ backgroundColor: '#1a1a1a', color: '#ccc', borderTop: '5px solid #138808' }}> {/* Green Border */}
    <div className="container py-4">

      {/* Copyright */}
      <div className="text-center small">
        <span className="text-white-50">
          &copy; 2026 National Scheduled Castes Finance and Development Corporation. All Rights Reserved.
        </span>
        <div className="mt-1 text-secondary" style={{ fontSize: '0.75rem' }}>
          Site designed and developed by NSFDC IT Department.
        </div>
      </div>
    </div>
  </footer>
    </div >
  );
};

export default Login;